import { useTranslation } from 'react-i18next';
import { Link } from '@tanstack/react-router';
import logo from '@/assets/images/logo.png';
import background from '@/assets/images/background.jpg';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div
      className="relative h-full min-h-screen w-auto bg-cover bg-center"
      style={{ backgroundImage: `url(${background})` }}
    >
      <img
        src={logo}
        alt="Dior"
        className="absolute left-1/2 top-[10%] h-[50px] w-auto -translate-x-1/2 -translate-y-1/2"
      />
      <div className="relative pt-[30vh] text-center text-white">
        <h1 className="text-[10em] font-medium leading-none">{t('404.404')}</h1>
        <h2 className="text-3xl">{t('404.pageNotFound')}</h2>
        <p className="mt-4">
          {t('404.description')}
          <br />
          <Link
            to="/"
            className="font-bold text-white no-underline"
            data-testid="not-found-home-link"
          >
            {t('404.goBackHome')}
          </Link>
        </p>
      </div>
    </div>
  );
}
